import React, { useState } from 'react';
import {HashLink as Link } from 'react-router-hash-link';
import { IoMenu, IoClose } from "react-icons/io5";
import { motion } from "framer-motion";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuVariants = {
    open: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 20,
      },
    },
    closed: {
      opacity: 0,
      x: "-100%",
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 20,
      },
    },
  };

  return (
    <div className='py-4 w-full fixed grad z-50'>
      <div className="flex justify-between items-center max-w-[1400px] md:mx-auto mx-4">
        {/* Logo */}
        <div className='text-3xl font-semibold'>
          <span className='text-secondary'>M.</span> Abu Bakar
        </div>

        {/* Navigation Links for Desktop */}
        <ul className='md:flex hidden gap-6 items-center uppercase text-md font-medium'>
          <li><Link smooth to='#home' className='hover:text-secondary duration-300'>Home</Link></li>
          <li><Link smooth to='#about' className='hover:text-secondary duration-300'>About</Link></li>
          <li><Link smooth to='#services' className='hover:text-secondary duration-300'>Services</Link></li>
          <li><Link smooth to='#portfolio' className='hover:text-secondary duration-300'>Portfolio</Link></li>
          <li><Link smooth to='#skills' className='hover:text-secondary duration-300'>Skills</Link></li>
          <li><Link smooth to='#testimonials' className='hover:text-secondary duration-300'>Testimonials</Link></li>
          <li><Link smooth to='#contact' className='hover:text-secondary duration-300'>Contact</Link></li>
        </ul>

        {/* Hamburger Menu Button for Mobile */}
        <button
          className='md:hidden text-3xl'
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <IoClose /> : <IoMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      <motion.div
        className="fixed top-[4.2rem] left-0 w-full h-screen grad flex flex-col gap-6 items-start p-6 uppercase text-md font-medium text-white md:hidden"
        initial="closed"
        animate={isOpen ? "open" : "closed"}
        variants={menuVariants}
      >
        <Link smooth to='#home' className='hover:text-secondary duration-300' onClick={() => setIsOpen(false)}>Home</Link>
        <Link smooth to='#about' className='hover:text-secondary duration-300' onClick={() => setIsOpen(false)}>About</Link>
        <Link smooth to='#services' className='hover:text-secondary duration-300' onClick={() => setIsOpen(false)}>Services</Link>
        <Link smooth to='#portfolio' className='hover:text-secondary duration-300' onClick={() => setIsOpen(false)}>Portfolio</Link>
        <Link smooth to='#skills' className='hover:text-secondary duration-300' onClick={() => setIsOpen(false)}>Skills</Link>
        <Link smooth to='#testimonials' className='hover:text-secondary duration-300' onClick={() => setIsOpen(false)}>Testimonials</Link>
        <Link smooth to='#contact' className='hover:text-secondary duration-300' onClick={() => setIsOpen(false)}>Contact</Link>
      </motion.div>
    </div>
  );
};

export default Header;
